import { submissionReviewState, submissionName } from '../../lib/formsView.js'

const LINKS = [
  { key: 'contactId', label: 'Contact', token: (id) => `contact:${id}` },
  { key: 'companyId', label: 'Company', token: (id) => `company:${id}` },
  { key: 'dealId', label: 'Deal', token: (id) => `deal:${id}` },
]

function Row({ label, value }) {
  if (value == null || value === '') return null
  return (
    <div style={{ display: 'flex', gap: 12, padding: '6px 0', borderBottom: '1px solid var(--color-divider-dark)' }}>
      <div style={{ flex: '0 0 130px', fontSize: 12, color: 'var(--color-muted)' }}>{label}</div>
      <div style={{ flex: 1, fontSize: 13, color: 'var(--color-white)', wordBreak: 'break-word' }}>{String(value)}</div>
    </div>
  )
}

export default function SubmissionPeek({ submission, onRelease, onKeep, onDelete, onClose, onOpenToken, busy, error }) {
  if (!submission) return null
  const s = submission
  const state = submissionReviewState(s)
  const isSuspect = s.spam?.verdict === 'suspect'
  const notReviewed = state === 'needs-review'
  const values = s.values || {}
  const ctx = s.context || {}
  return (
    <div role="dialog" aria-label="Submission detail" style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: 'min(460px, 92vw)', background: 'var(--color-panel)', borderLeft: '1px solid var(--color-divider-dark)', boxShadow: '-8px 0 30px rgba(0,0,0,.35)', zIndex: 60, overflowY: 'auto', padding: '18px 20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 16, color: 'var(--color-white)' }}>{submissionName(s)}</div>
        <button onClick={onClose} aria-label="Close" className="btn" style={{ background: 'transparent', border: 'none', color: 'var(--color-muted)', fontSize: 20, cursor: 'pointer' }}>×</button>
      </div>

      {isSuspect && (
        <div style={{ background: 'rgba(217,83,79,.1)', border: '1px solid rgba(217,83,79,.4)', borderRadius: 'var(--radius-md)', padding: '10px 12px', marginBottom: 14 }}>
          <div style={{ fontSize: 12, color: 'var(--color-white)', marginBottom: 4 }}>Quarantined — {state === 'released' ? 'released' : state === 'kept' ? 'kept as spam' : 'needs review'}</div>
          <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>Reasons: {(s.spam?.reasons || []).join(', ') || 'unknown'}</div>
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        {Object.keys(values).map((k) => <Row key={k} label={k} value={values[k]} />)}
      </div>

      {(s.contactId || s.companyId || s.dealId) && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--color-muted)', marginBottom: 6 }}>Created records</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {LINKS.filter((l) => s[l.key]).map((l) => (
              <button key={l.key} onClick={() => onOpenToken(l.token(s[l.key]))} className="btn" style={{ fontSize: 12, padding: '5px 10px', border: '1px solid var(--color-divider-dark)', background: 'transparent', color: 'var(--color-gold)' }}>{l.label}</button>
            ))}
          </div>
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--color-muted)', marginBottom: 6 }}>Context</div>
        <Row label="Page" value={ctx.pageName || ctx.pageUri} />
        <Row label="Referrer" value={ctx.referrer} />
        <Row label="UTM source" value={ctx.utm?.source} />
        <Row label="UTM campaign" value={ctx.utm?.campaign} />
      </div>

      {error && <div style={{ fontSize: 12, color: 'var(--color-danger, #d9534f)', marginBottom: 10 }}>{error}</div>}

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {isSuspect && notReviewed && (
          <>
            <button onClick={onRelease} disabled={busy} className="btn btn-gold" style={{ fontSize: 12, padding: '8px 14px' }}>Release to CRM</button>
            <button onClick={onKeep} disabled={busy} className="btn" style={{ fontSize: 12, padding: '8px 14px', border: '1px solid var(--color-divider-dark)', background: 'transparent', color: 'var(--color-muted)' }}>Keep as spam</button>
          </>
        )}
        <button onClick={onDelete} disabled={busy} className="btn" style={{ fontSize: 12, padding: '8px 14px', border: '1px solid var(--color-divider-dark)', background: 'transparent', color: 'var(--color-danger, #d9534f)' }}>Delete</button>
      </div>
    </div>
  )
}
